module.exports = __webpack_public_path__ + "static/img/zf_img_function05.8377d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/zf_img_function05.png
// module id = xscN
// module chunks = 1